import * as i0 from '@angular/core';
import { Injectable } from '@angular/core';
import { BaseApiService } from '@prv/apis';
import * as i1 from '@angular/common/http';
import * as i2 from '@nexa/configuration';

/**
 * Representa la información del afiliado obtenida desde el web service
 */
class ResponseDto {
}

/**
 * Representa la información de entrada necesaria para realizar una solicitud al web service
 */
class RequestDto {
}

class InteractionCrmApiService extends BaseApiService {
    /**
     * Crea una nueva instancia de @see InteractionCrmApiService
     */
    constructor(httpClient, configuration) {
        super(httpClient, configuration, 'interaction-crm', 'Interaction');
    }
    /**
     * Método encargado de enviar al web service los datos de interacción para almacenarlos en el CRM de Porvenir
     * @param data Información del afiliado
     * @returns Objeto de tipo @see ResponseDto con la respuesta de la transacción
     * @example
     * // Post interaction data to save it on the Porvenir CRM
     * this.service.postInteraction({}).subscribe((x) => console.log(x));
     */
    postInteraction(data) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/PostInteraction`, data));
    }
    /**
     * Método encargado de enviar al web service los datos de interacción para almacenarlos en el CRM de Porvenir desde aplicacione externas
     * @param data Información del afiliado
     * @returns Una cadena de tipo @see DataExternalDto con la respuesta de la transacción
     * @example
     * // Post interaction data to save it on the Porvenir CRM
     * this.service.postInteraction({}).subscribe((x) => console.log(x));
     */
    postInteractionExtenal(data) {
        return this.getUri((uri) => this.httpClient.post(`${uri}/PostInteractionExternal`, data));
    }
}
InteractionCrmApiService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionCrmApiService, deps: [{ token: i1.HttpClient }, { token: i2.NexaConfigurationService }], target: i0.ɵɵFactoryTarget.Injectable });
InteractionCrmApiService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionCrmApiService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.2.7", ngImport: i0, type: InteractionCrmApiService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }, { type: i2.NexaConfigurationService }]; } });

/*
 * Public API Surface of ws-interaction
 */

/**
 * Generated bundle index. Do not edit.
 */

export { InteractionCrmApiService, RequestDto, ResponseDto };
